export default __webpack_public_path__ + "images/7c5ecb453faba9d3c6cc57fafec6715a-4_4K_1920x544.webp";